// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTabs-root {
  background: var(--white);
}

.MuiTabs-flexContainer {
  border-bottom: 1px solid var(--black1);
}

.StyledTreeView {
  width: 100%;
  padding: 0;
  max-height: 100%;
  padding-bottom: 0;
  height: calc(100vh - 3.5rem - 4.5rem);
  overflow: auto;
  position: relative;
}
.StyledTreeView .MuiCollapse-root {
  margin-left: 13px;
}

.StyledTreeItem {
  color: var(--black9);
}
.StyledTreeItem:hover {
  color: var(--black9);
}
.StyledTreeItem .MuiTreeItem-content {
  height: 30px;
  border-radius: 0.5rem;
  margin-bottom: 2px;
}
.StyledTreeItem .MuiTreeItem-content .MuiTreeItem-iconContainer svg {
  font-size: 14px;
}
.StyledTreeItem .MuiTreeItem-content .MuiTreeItem-label {
  font-size: 12px;
  padding-left: 2px;
}
.StyledTreeItem .MuiTreeItem-content .MuiTreeItem-label .MuiTypography-root {
  font-size: 12px;
}
.StyledTreeItem .MuiTreeItem-content .MuiTreeItem-label .MuiIconButton-root {
  padding: 0;
  width: 20px;
  height: 20px;
  color: inherit;
}
.StyledTreeItem .MuiTreeItem-content .MuiTreeItem-label .MuiIconButton-root svg {
  font-size: 14px;
}
.StyledTreeItem .MuiTreeItem-content:hover .MuiIconButton-root {
  opacity: 1;
}

.StyledTabList {
  min-height: 40px;
  background: var(--black9);
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.StyledTab {
  padding: 8px 8px 8px 12px;
  min-height: 40px;
  color: var(--black0);
  text-transform: none;
}
.StyledTab .MuiTypography-root {
  margin-right: 5px;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}
.StyledTab.Mui-selected {
  color: var(--black0);
}
.StyledTab .MuiSvgIcon-root#tab-notif {
  font-size: 8px;
  margin-right: 5px;
}
.StyledTab .MuiBox-root#close-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: inherit;
}
.StyledTab .MuiBox-root#close-button:hover {
  background: red;
}
.StyledTab .MuiBox-root#close-button svg {
  width: 18px;
  height: 18px;
}

.StyledTabPanel {
  position: relative;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/builder/screens/code/tabs.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,oBAAA;AAAF;AAEE;EACE,oBAAA;AAAJ;AAGE;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;AADJ;AAIQ;EACE,eAAA;AAFV;AAMI;EACE,eAAA;EACA,iBAAA;AAJN;AAMM;EACE,eAAA;AAJR;AAOK;EACC,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AALN;AAOQ;EACE,eAAA;AALV;AAWQ;EACE,UAAA;AATV;;AAeA;EACE,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,+BAAA;AAZF;;AAeA;EACE,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;AAZF;AAcE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAZJ;AAeE;EACE,oBAAA;AAbJ;AAgBE;EACE,cAAA;EACA,iBAAA;AAdJ;AAiBC;EACG,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAfJ;AAiBI;EACE,eAAA;AAfN;AAkBI;EACE,WAAA;EACA,YAAA;AAhBN;;AAqBA;EACE,kBAAA;EACA,UAAA;AAlBF","sourcesContent":[".MuiTabs-root {\n  background: var(--white);\n}\n\n.MuiTabs-flexContainer {\n  border-bottom: 1px solid var(--black1);\n}\n\n.StyledTreeView {\n  width: 100%;\n  padding: 0;\n  max-height: 100%;\n  padding-bottom: 0;\n  height: calc(100vh - 3.5rem - 4.5rem);\n  overflow: auto;\n  position: relative;\n\n  .MuiCollapse-root {\n    margin-left: 13px\n  }\n}\n\n.StyledTreeItem {\n  color: var(--black9);\n\n  &:hover {\n    color: var(--black9);\n  };\n\n  .MuiTreeItem-content {\n    height: 30px;\n    border-radius: .5rem;\n    margin-bottom: 2px;\n\n    .MuiTreeItem-iconContainer {\n        svg {\n          font-size: 14px;\n        };\n    };\n\n    .MuiTreeItem-label {\n      font-size: 12px;\n      padding-left: 2px;\n\n      .MuiTypography-root {\n        font-size: 12px;\n      };\n\n     .MuiIconButton-root {\n      padding: 0;\n      width: 20px;\n      height: 20px;\n      color: inherit;\n\n        svg {\n          font-size: 14px;\n        };\n      };\n    };\n\n    &:hover {\n        .MuiIconButton-root {\n          opacity: 1;\n        }\n      }\n  }\n}\n\n.StyledTabList {\n  min-height: 40px;\n  background: var(--black9);\n  border-top-left-radius: .5rem;\n  border-top-right-radius: .5rem;\n}\n\n.StyledTab {\n  padding: 8px 8px 8px 12px;\n  min-height: 40px;\n  color: var(--black0);\n  text-transform: none;\n\n  .MuiTypography-root {\n    margin-right: 5px;\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 12px;\n  };\n\n  &.Mui-selected {\n    color: var(--black0);\n  };\n\n  .MuiSvgIcon-root#tab-notif {\n    font-size: 8px;\n    margin-right: 5px;\n  };\n\n .MuiBox-root#close-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 4px;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    color: inherit;\n\n    &:hover {\n      background: red;\n    };\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n.StyledTabPanel {\n  position: relative;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
